import React from "react";
import { Skeleton } from "antd";
import { generateGUID } from "../../../utils/MainHelper.js";

function PieSkeleton() {
    return (
        <div
            className="d-flex"
            style={{
                height: "100%", width: "100%"
            }}
        >
            <div
                className="d-flex align-items-center justify-content-center"
                style={{
                    height: "100%", width: "80%"
                }}
            >
                <Skeleton.Avatar
                    active
                    shape="circle"
                    style={{
                        height: "80mm", width: "80mm"
                    }}
                />
            </div>
            <div
                className="d-flex-col"
                style={{
                    height: "100%",
                    width: "20%",
                    paddingTop: "10%"
                }}
            >
                { "11111111".split("").map(() => (
                    <div className="d-flex gap-5p" key={generateGUID()}>
                        <Skeleton.Avatar
                            active
                            shape="circle"
                            style={{
                                height: "4mm", width: "4mm"
                            }}
                        />
                        <Skeleton.Button
                            className="flex-1"
                            active
                            shape="round"
                            style={{
                                height: "4mm"
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PieSkeleton;
